export enum actionTypes {
    TERMS_AND_CONDITIONS_HISTORY_DATA_UPDATE = 'TERMS_AND_CONDITIONS_HISTORY:DATA:UPDATE',
    TERMS_AND_CONDITIONS_HISTORY_IS_LOADING_TOGGLE = 'TERMS_AND_CONDITIONS_HISTORY:IS_LOADING:TOGGLE'
}
